<template>
  <div>
    <v-combobox
      ref="input"
      :value="value"
      :search-input.sync="query"
      :items="items"
      :loading="loading"
      item-text="label"
      item-value="tracking_url"
      :return-object="false"
      hide-details
      outline
      single-line
      @input="$emit('input', $event)"
    >
      <template #item="{ item }">
        <v-list-tile-content>
          <v-list-tile-title>{{ item.label }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ item.tracking_url }}</v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
      <template #append-outer>
        <v-btn flat color="primary" class="ma-0" @click="openCreateDialog">
          <v-icon>add</v-icon>
          {{ $t('add_link') }}
        </v-btn>
      </template>
    </v-combobox>
    <v-dialog v-model="createDialog.open" :width="500">
      <v-card :key="createDialog.key">
        <iframe
          v-if="iframeSrc"
          ref="iframe"
          sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
          :src="iframeSrc"
          :style="{ display: 'block', border: 'none', width: '100%', height: '80dvh' }"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import debounce from 'lodash/debounce'
import eventTrackingApi from '@/api/event-tracking'

export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      query: this.value,
      items: [],
      loading: false,
      createDialog: {
        open: false,
        key: Date.now()
      },
      debouncedFetch: undefined
    }
  },
  computed: {
    ...mapGetters(['currentLang', 'selectedBot']),
    iframeSrc() {
      if (!this.currentLang) return ''
      return `https://event-tracking.zwiz.app/${this.currentLang}/links/create`
    }
  },
  watch: {
    query() {
      this.debouncedFetch()
    }
  },
  created() {
    this.debouncedFetch = debounce(this.fetchItems, 500)
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    async fetchItems() {
      try {
        this.loading = true

        const response = await eventTrackingApi.getTrackingUrls(this.selectedBot.pageid, {
          offset: 0,
          limit: 25,
          date_from: dayjs(0).format(),
          date_to: dayjs().format(),
          label: this.query
        })
        if (response.status === 200) {
          this.items = response.data.data
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    openCreateDialog() {
      this.$refs.input.blur()
      this.createDialog = {
        open: true,
        key: Date.now()
      }
    },
    handleMessage(e) {
      if (e.source !== this.$refs.iframe.contentWindow) return

      const { id } = e.data
      switch (id) {
        case 'link-create-submit': {
          this.createDialog.open = false
          break
        }
        case 'link-create-cancel': {
          this.createDialog.open = false
          break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/chatbot/LinkTrackingSelect.vue